import { ModuleFE_Message } from './ModuleFE_Message.js';
import { ModuleFE_Topic } from './ModuleFE_Topic.js';
export const ModulePackFE_Messaging = [
    ModuleFE_Message,
    ModuleFE_Topic
];
//# sourceMappingURL=module-pack.js.map